import React, { createContext, useContext } from 'react';
import { useAdvise } from '../../hooks/useAdvise';

export const InitialStepFormContext = createContext(null);

const InitialStepFormContextProvider = ({ children }) => {
    const { resetAdvises, handleShowAdvise, state } = useAdvise();

    const isAdviseShown = Object.values(state).some(Boolean);

    const shouldShowNotResidentAdvise = state.resident && !state.underage && !state.vulnerablyOlder;
    const shouldShowUnderageAdvise = state.underage;
    const shouldShowVulnerablyOlderAdvise = state.vulnerablyOlder;
    const shouldShowJointHolderDocAdvise = state.jointHolder;

    return (
        <InitialStepFormContext.Provider
            value={{
                handleShowAdvise,
                isAdviseShown,
                resetAdvises,
                shouldShowJointHolderDocAdvise,
                shouldShowNotResidentAdvise,
                shouldShowUnderageAdvise,
                shouldShowVulnerablyOlderAdvise,
            }}
        >
            {children}
        </InitialStepFormContext.Provider>
    );
};

export default InitialStepFormContextProvider;

export const useInitialStepForm = () => {
    const context = useContext(InitialStepFormContext);
    if (!context) {
        throw new Error('useInitialStepForm must be used within an InitialStepFormProvider');
    }

    return context;
};
